var chunkToChildrenMap = {
	"AgentHistory": [
		"styles",
		"CustomizedBuildNote"
	],
	"AllBuilds": [
		"styles",
		"CustomizedBuildNote"
	],
	"Builds": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildsTvMode": [
		"styles",
		"CustomizedBuildNote"
	],
	"FavoriteBuilds": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildActionsDropdown": [
		"styles",
		"CustomizedBuildNote"
	],
	"FavoriteBuildsPage": [
		"styles",
		"CustomizedBuildNote"
	],
	"ChangeDetailsTabs": [
		"styles",
		"CustomizedBuildNote"
	],
	"ChangePage": [
		"styles",
		"CustomizedBuildNote"
	],
	"ChangesPage": [
		"styles",
		"vendors-node_modules_jetbrains_ring-ui_components_dropdown-menu_dropdown-menu_js-node_modules-891abc",
		"vendors-node_modules_jetbrains_ring-ui_components_tabs_tabs_js",
		"vendors-node_modules_anser_lib_index_js",
		"vendors-node_modules_yet-another-react-lightbox_dist_plugins_captions_index_js-node_modules_y-df2a44",
		"vendors-node_modules_jetbrains_ring-ui_components_tags-input_tags-input_js-node_modules_jetbr-db6e03",
		"components_common_BuildStatus_BuildStatus_tsx",
		"components_common_ArtifactChanges_ArtifactChanges_tsx",
		"components_packages_Changes_BuildChangesDropdown_BuildChangesDropdown_tsx",
		"components_common_BuildActionsDropdown_BuildActionsDropdown_tsx",
		"components_common_BranchLabel_BuildBranchLabel_container_ts-components_common_BuildApproval_B-b7b4f2",
		"components_common_Builds_Builds_tsx",
		"components_packages_BuildLog_BuildLogInfo_BuildLogInfo_tsx-components_packages_BuildLog_Build-ef976c",
		"components_common_Investigations_InvestigationDetails_tsx-components_common_Mutes_MuteDetails-e1e970",
		"components_common_ArrowPopupMenu_ArrowPopupMenu_tsx-components_common_Tree_Tree_tsx-component-792068",
		"components_packages_Tests_InvestigationMuteButtons_InvestigationMuteButtons_tsx-components_pa-69729b",
		"components_common_Investigations_TestInvestigations_tsx-components_common_Mutes_TestMutes_tsx-00545a",
		"components_packages_Tests_TestsTree_TestsTree_tsx",
		"components_packages_BuildProblems_BuildProblemsTree_BuildProblemsTree_container_tsx-component-266f66",
		"ChangeDetailsTabs"
	],
	"AgentPage": [
		"styles",
		"AgentBuildTypes",
		"CustomizedBuildNote"
	],
	"AgentPoolPage": [
		"styles",
		"EditAgentPoolForm",
		"CustomizedBuildNote"
	],
	"AgentPoolsFavoritePage": [
		"styles",
		"EditAgentPoolForm",
		"CustomizedBuildNote"
	],
	"AgentsOverviewPage": [
		"styles",
		"EditAgentPoolForm",
		"CustomizedBuildNote"
	],
	"AgentTypePage": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildPage": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildOverviewTab": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildTestsTab": [
		"styles",
		"vendors-node_modules_victory-area_es_victory-area_js-node_modules_victory-chart_es_victory-ch-98b9be",
		"vendors-node_modules_victory-bar_es_victory-bar_js-node_modules_victory-brush-container_es_vi-4c5fb8",
		"vendors-node_modules_simplify-js_simplify_js-node_modules_victory-pie_es_victory-pie_js",
		"TestHistoryChart"
	],
	"DependenciesTab": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildTypePage": [
		"styles",
		"CustomizedBuildNote"
	],
	"ProjectPage": [
		"styles",
		"CustomizedBuildNote"
	],
	"EditPipelinePage": [
		"styles",
		"components_common_Popup_Popup_ts-components_pages_PipelinesPages_EditPipelinePage_EditPipelin-f25381",
		"PipelineChart",
		"vendors-node_modules_uiw_react-codemirror_esm_index_js-node_modules_lezer_yaml_dist_index_js--0afdca",
		"YamlEditor"
	],
	"QueuePage": [
		"styles",
		"CustomizedBuildNote"
	],
	"App": [
		"styles",
		"vendors-node_modules_react-virtualized_dist_es_AutoSizer_index_js-node_modules_react-virtuali-e968da",
		"vendors-node_modules_jetbrains_ring-ui_components_list_list_js",
		"vendors-node_modules_jetbrains_ring-ui_components_tabs_tabs_js",
		"vendors-node_modules_jetbrains_ring-ui_components_global_normalize-indent_js-node_modules_jet-382d92",
		"vendors-node_modules_inline-svg-unique-id_react_lib_index_js-node_modules_jetbrains_ring-ui_c-149c15",
		"Hints",
		"vendors-node_modules_anser_lib_index_js",
		"components_packages_BuildLog_BuildLogInfo_BuildLogInfo_tsx-components_packages_BuildLog_Build-ef976c",
		"components_packages_BuildLog_BuildLogTimeline_BuildLogTimeline_container_ts-components_packag-a7fc74",
		"components_packages_BuildLog_FullBuildLog_FullBuildLog_container_tsx",
		"FullBuildLog",
		"BuildLogPopupHeader"
	],
	"BuildDetailsContent": [
		"styles",
		"CustomizedBuildNote"
	],
	"AgentsSidebar": [
		"styles",
		"EditAgentPoolForm"
	],
	"BuildTypeOverview": [
		"styles",
		"CustomizedBuildNote"
	],
	"BuildTypeHistory": [
		"styles",
		"CustomizedBuildNote"
	],
	"CleanupProjectPage": [
		"styles",
		"vendors-node_modules_jetbrains_ring-ui_components_select_select_js",
		"components_common_BranchSelect_BranchSelect_container_tsx",
		"CleanupForm"
	],
	"Rules": [
		"styles",
		"vendors-node_modules_jetbrains_ring-ui_components_select_select_js",
		"components_common_BranchSelect_BranchSelect_container_tsx",
		"CleanupForm"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };